import React from 'react';

import { Modal, Row, Col, Avatar } from 'antd';
import {COLOR_SUCCESS} from "./../shared/constants";
const CustomModal = (props) => { 
  
  const { dataModal ,setDataModal} = props;
  const handleOk = () => {  
    setDataModal({...dataModal, modalVisible: false, success: true }) 
  };
  const handleCancel = () => {
    setDataModal({...dataModal, modalVisible: false, success: false })
  }
  return (
    <>
      <Modal
        open={dataModal.modalVisible}
        onCancel={handleCancel} 
        width={550} // Garantiza que el estado se actualice después de que el modal se cierre
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps= {{
          className: "custom-submit-button",
          style: { width: '100%', marginTop: '5vh', margin: '0 auto', display: 'block' }
        }}
        onOk = {handleOk}
        okText="Entendido"
        mask
        maskClosable
        wrapClassName="backgroundModal" 
      >
        <Row>
          <Col span={24}>
            <Avatar
              icon={dataModal.icon}
              style={{
                backgroundColor: !dataModal.color?COLOR_SUCCESS:dataModal.color,
                width: '5vh',
                height: '5vh',
                lineHeight: '5vh',
                lineWidth: '5vh',
              }}
              shape="circle"
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <p className="titleColor">{dataModal.title===""?"Mensaje":dataModal.title} </p>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <p className="pompisLight pompisSemiBold" style={{ marginTop: '2vh',marginBottom: '2vh' }}>{dataModal.message}</p>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default CustomModal;
